import useOWebViewMessage from './useOWebViewMessage';

export default function useWebViewPrevUrl() {
  const message = useOWebViewMessage('INITIAL');
  return message?.value.prevUrl;
}
